import React, { useState } from 'react';
import { UtensilsIcon, WashingMachineIcon, CalendarIcon, ClockIcon, CheckCircleIcon, XCircleIcon } from 'lucide-react';
import Header from '../components/Header';
// Genereer beschikbaarheid voor de komende 3 dagen
const generateAvailability = () => {
  const result = {};
  const days = ['Vandaag', 'Morgen', 'Overmorgen'];
  days.forEach(day => {
    result[day] = {
      bbq: {
        ochtend: Math.floor(Math.random() * 3),
        middag: Math.floor(Math.random() * 4),
        avond: Math.floor(Math.random() * 5)
      },
      fietsen: {
        ochtend: Math.floor(Math.random() * 6),
        middag: Math.floor(Math.random() * 4),
        avond: Math.floor(Math.random() * 3)
      },
      wasmachines: {
        ochtend: Math.floor(Math.random() * 3),
        middag: Math.floor(Math.random() * 3),
        avond: Math.floor(Math.random() * 3)
      }
    };
  });
  return result;
};
const Facilities = () => {
  const [selectedDate, setSelectedDate] = useState('Vandaag');
  const [availability, setAvailability] = useState(generateAvailability());
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [confirmedBooking, setConfirmedBooking] = useState(null);
  const handleReservation = (facility, time) => {
    // Update availability
    const newAvailability = {
      ...availability
    };
    newAvailability[selectedDate][facility][time]--;
    setAvailability(newAvailability);
    // Show confirmation
    setConfirmedBooking({
      facility: facility === 'bbq' ? 'BBQ-plek' : facility === 'fietsen' ? 'Fiets' : 'Wasmachine',
      time: time === 'ochtend' ? 'ochtend (8:00 - 12:00)' : time === 'middag' ? 'middag (12:00 - 17:00)' : 'avond (17:00 - 21:00)',
      day: selectedDate
    });
    setShowConfirmation(true);
  };
  const getDayLabel = day => {
    if (day === 'Vandaag') return new Date().toLocaleDateString('nl-NL', {
      weekday: 'long'
    });
    if (day === 'Morgen') {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow.toLocaleDateString('nl-NL', {
        weekday: 'long'
      });
    }
    if (day === 'Overmorgen') {
      const dayAfterTomorrow = new Date();
      dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);
      return dayAfterTomorrow.toLocaleDateString('nl-NL', {
        weekday: 'long'
      });
    }
    return day;
  };
  if (showConfirmation) {
    return <div className="flex flex-col min-h-full bg-gray-50" data-id="element-283">
        <Header title="Faciliteiten Reserveren" showBackButton data-id="element-284" />
        <div className="p-4 flex-1 flex flex-col items-center justify-center" data-id="element-285">
          <div className="bg-white rounded-lg shadow-sm p-6 w-full max-w-md text-center" data-id="element-286">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-287">
              <CheckCircleIcon size={32} className="text-green-600" data-id="element-288" />
            </div>
            <h2 className="text-xl font-bold mb-2" data-id="element-289">Reservering Bevestigd!</h2>
            <p className="text-gray-600 mb-6" data-id="element-290">
              Je hebt succesvol een {confirmedBooking.facility} gereserveerd
              voor {confirmedBooking.day.toLowerCase()} {confirmedBooking.time}.
            </p>
            <div className="bg-gray-50 rounded-lg p-4 mb-6 text-left" data-id="element-291">
              <div className="flex items-center mb-2" data-id="element-292">
                <CalendarIcon size={18} className="text-[#f9b30f] mr-2" data-id="element-293" />
                <span data-id="element-294">{getDayLabel(confirmedBooking.day)}</span>
              </div>
              <div className="flex items-center mb-2" data-id="element-295">
                <ClockIcon size={18} className="text-[#f9b30f] mr-2" data-id="element-296" />
                <span data-id="element-297">{confirmedBooking.time}</span>
              </div>
              <div className="flex items-center" data-id="element-298">
                {confirmedBooking.facility === 'BBQ-plek' ? <UtensilsIcon size={18} className="text-[#f9b30f] mr-2" data-id="element-299" /> : confirmedBooking.facility === 'Fiets' ? <div size={18} className="text-[#f9b30f] mr-2" data-id="element-300" /> : <WashingMachineIcon size={18} className="text-[#f9b30f] mr-2" data-id="element-301" />}
                <span data-id="element-302">{confirmedBooking.facility}</span>
              </div>
            </div>
            <button onClick={() => setShowConfirmation(false)} className="bg-[#f9b30f] text-black py-2 px-4 rounded-lg font-medium" data-id="element-303">
              Terug naar reserveringen
            </button>
          </div>
        </div>
      </div>;
  }
  return <div className="flex flex-col min-h-full bg-gray-50" data-id="element-304">
      <Header title="Faciliteiten Reserveren" showBackButton data-id="element-305" />
      <div className="p-4" data-id="element-306">
        <div className="flex space-x-2 overflow-x-auto pb-2 mb-4" data-id="element-307">
          <DateButton label="Vandaag" sublabel={getDayLabel('Vandaag')} active={selectedDate === 'Vandaag'} onClick={() => setSelectedDate('Vandaag')} data-id="element-308" />
          <DateButton label="Morgen" sublabel={getDayLabel('Morgen')} active={selectedDate === 'Morgen'} onClick={() => setSelectedDate('Morgen')} data-id="element-309" />
          <DateButton label="Overmorgen" sublabel={getDayLabel('Overmorgen')} active={selectedDate === 'Overmorgen'} onClick={() => setSelectedDate('Overmorgen')} data-id="element-310" />
        </div>
        <h2 className="text-lg font-bold mb-4" data-id="element-311">Beschikbare Faciliteiten</h2>
        <div className="space-y-4" data-id="element-312">
          <FacilityCard icon={<div size={24} data-id="element-314" />} title="Fietsen" description="Huur een fiets om de omgeving te verkennen" slots={[{
          id: 1,
          time: 'Ochtend (8:00 - 12:00)',
          available: availability[selectedDate].fietsen.ochtend,
          timeSlot: 'ochtend',
          facility: 'fietsen'
        }, {
          id: 2,
          time: 'Middag (12:00 - 17:00)',
          available: availability[selectedDate].fietsen.middag,
          timeSlot: 'middag',
          facility: 'fietsen'
        }, {
          id: 3,
          time: 'Avond (17:00 - 21:00)',
          available: availability[selectedDate].fietsen.avond,
          timeSlot: 'avond',
          facility: 'fietsen'
        }]} onReserve={handleReservation} data-id="element-313" />
          <FacilityCard icon={<UtensilsIcon size={24} data-id="element-316" />} title="BBQ-plekken" description="Reserveer een BBQ-plek voor een gezellige avond" slots={[{
          id: 1,
          time: 'Middag (12:00 - 17:00)',
          available: availability[selectedDate].bbq.middag,
          timeSlot: 'middag',
          facility: 'bbq'
        }, {
          id: 2,
          time: 'Avond (17:00 - 21:00)',
          available: availability[selectedDate].bbq.avond,
          timeSlot: 'avond',
          facility: 'bbq'
        }]} onReserve={handleReservation} data-id="element-315" />
          <FacilityCard icon={<WashingMachineIcon size={24} data-id="element-318" />} title="Wasmachines" description="Reserveer een tijdslot voor de wasmachine" slots={[{
          id: 1,
          time: 'Ochtend (8:00 - 10:00)',
          available: availability[selectedDate].wasmachines.ochtend,
          timeSlot: 'ochtend',
          facility: 'wasmachines'
        }, {
          id: 2,
          time: 'Middag (12:00 - 14:00)',
          available: availability[selectedDate].wasmachines.middag,
          timeSlot: 'middag',
          facility: 'wasmachines'
        }, {
          id: 3,
          time: 'Avond (18:00 - 20:00)',
          available: availability[selectedDate].wasmachines.avond,
          timeSlot: 'avond',
          facility: 'wasmachines'
        }]} onReserve={handleReservation} data-id="element-317" />
        </div>
        <div className="mt-6 bg-white rounded-lg shadow-sm p-4" data-id="element-319">
          <h3 className="font-bold mb-2" data-id="element-320">Reserveringsinfo</h3>
          <p className="text-sm text-gray-600 mb-3" data-id="element-321">
            Reserveringen kunnen tot 2 uur van tevoren geannuleerd worden bij de
            receptie. Voor fietsverhuur is een geldig identiteitsbewijs nodig.
          </p>
          <div className="flex items-center text-sm text-gray-600" data-id="element-322">
            <ClockIcon size={16} className="mr-2 text-[#f9b30f]" data-id="element-323" />
            <span data-id="element-324">Receptie is geopend van 8:00 tot 20:00</span>
          </div>
        </div>
      </div>
    </div>;
};
const DateButton = ({
  label,
  sublabel,
  active,
  onClick
}) => {
  return <button className={`py-2 px-4 rounded-lg ${active ? 'bg-[#f9b30f] text-black' : 'bg-white text-gray-600 border border-gray-200'}`} onClick={onClick} data-id="element-325">
      <div className="text-sm font-medium" data-id="element-326">{label}</div>
      <div className="text-xs" data-id="element-327">{sublabel}</div>
    </button>;
};
const FacilityCard = ({
  icon,
  title,
  description,
  slots,
  onReserve
}) => {
  return <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-328">
      <div className="flex items-center mb-3" data-id="element-329">
        <div className="text-[#f9b30f] mr-3" data-id="element-330">{icon}</div>
        <div data-id="element-331">
          <h3 className="font-bold" data-id="element-332">{title}</h3>
          <p className="text-sm text-gray-600" data-id="element-333">{description}</p>
        </div>
      </div>
      <div className="space-y-2" data-id="element-334">
        {slots.map(slot => <div key={slot.id} className="flex justify-between items-center border-t pt-2" data-id="element-335">
            <span className="text-sm" data-id="element-336">{slot.time}</span>
            {slot.available > 0 ? <div className="flex items-center" data-id="element-337">
                <span className="text-sm text-gray-600 mr-2" data-id="element-338">
                  {slot.available} beschikbaar
                </span>
                <button className="bg-[#f9b30f] text-black p-2 rounded-lg" onClick={() => onReserve(slot.facility, slot.timeSlot)} data-id="element-339">
                  Reserveer
                </button>
              </div> : <div className="flex items-center text-red-500" data-id="element-340">
                <XCircleIcon size={16} className="mr-1" data-id="element-341" />
                <span className="text-sm" data-id="element-342">Niet beschikbaar</span>
              </div>}
          </div>)}
      </div>
    </div>;
};
export default Facilities;